import PropTypes from 'prop-types';
import { Field as ReduxFormField } from 'redux-form';
import { Field as FinalFormField } from 'react-final-form';
import { GroupControl } from '../../GroupField';
import SelectControl from '../Control';

export default function SelectGroupField({
  isReactFinalForm = false,
  ...props
}) {
  const Field = isReactFinalForm ? FinalFormField : ReduxFormField;

  return (
    <Field {...props} component={GroupControl} FormControl={SelectControl} />
  );
}

SelectGroupField.propTypes = {
  isReactFinalForm: PropTypes.bool,
};
